import { createSelector } from '../reselect';
import { getNewStats, total, last, simpleChart, simpleChart2, safeDivide } from '../generalUtils';

const providerId = 'recharge';

const shopifySales = createSelector([getNewStats], (stats) =>
  total(stats['shopify'], 'total_price')
);
const subscriptionSales = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'subscription_sales')
);

const shopifySalesChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats['shopify'], 'total_price')
);
const subscriptionSalesChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'subscription_sales')
);

const rechargeSubscription1stOrderSales = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'one_st_first_order')
);
const rechargeSubscription1stOrderSalesChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'one_st_first_order')
);

const rechargeSubscriptionRecurringOrder = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'recurring_order_subscription')
);
const rechargeSubscriptionRecurringOrderChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'recurring_order_subscription')
);

const rechargeTotalSubscriptionSales = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'subscription_sales')
);
const rechargeTotalSubscriptionSalesChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'subscription_sales')
);

const rechargeSubscriptionSalesPercentage = createSelector(
  [shopifySales, subscriptionSales],
  (shopifySales, subscriptionSales) => {
    return safeDivide(100 * subscriptionSales, shopifySales);
  }
);
const rechargeSubscriptionSalesPercentageChart = createSelector(
  [shopifySalesChart, subscriptionSalesChart],
  (shopifySalesChart, subscriptionSalesChart) =>
    simpleChart2(subscriptionSalesChart, shopifySalesChart, { chart1yMultiplier: 100 })
);

const rechargeTotalNewSubscriptions = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'total_new_subscriptions')
);
const rechargeTotalNewSubscriptionsChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'total_new_subscriptions')
);

const rechargeTotalCancelledSubscriptions = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'total_cancelled_subscriptions')
);
const rechargeTotalCancelledSubscriptionsChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'total_cancelled_subscriptions')
);

const rechargeTotalChurnedSubscribers = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'total_churned_subscribers')
);
const rechargeTotalChurnedSubscribersChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'total_churned_subscribers')
);

const rechargeTotalActiveSubscriptions = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'total_active_subscriptions')
);
const rechargeTotalActiveSubscriptionsChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'total_active_subscriptions')
);

const rechargeTotalActiveSubscribers = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'total_active_subscribers')
);
const rechargeTotalActiveSubscribersChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'total_active_subscribers')
);

const rechargeAverageActiveDays = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'average_active_days')
);
const rechargeAverageActiveDaysChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'average_active_days')
);

const rechargeAverageSubscriptionsPerCustomer = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'average_active_subscriptions_per_customer')
);
const rechargeAverageSubscriptionsPerCustomerChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'average_active_subscriptions_per_customer')
);

const rechargeReactivatedSubscribers = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'reactivated_subscribers')
);

const rechargeReactivatedSubscribersChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'reactivated_subscribers')
);

const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    rechargeSubscription1stOrderSales,
    rechargeSubscription1stOrderSalesChart,
    rechargeSubscriptionRecurringOrder,
    rechargeSubscriptionRecurringOrderChart,
    rechargeTotalSubscriptionSales,
    rechargeTotalSubscriptionSalesChart,
    rechargeSubscriptionSalesPercentage,
    rechargeSubscriptionSalesPercentageChart,
    rechargeTotalNewSubscriptions,
    rechargeTotalNewSubscriptionsChart,
    rechargeTotalCancelledSubscriptions,
    rechargeTotalCancelledSubscriptionsChart,
    rechargeTotalChurnedSubscribers,
    rechargeTotalChurnedSubscribersChart,
    rechargeTotalActiveSubscriptions,
    rechargeTotalActiveSubscriptionsChart,
    rechargeTotalActiveSubscribers,
    rechargeTotalActiveSubscribersChart,
    rechargeAverageActiveDays,
    rechargeAverageActiveDaysChart,
    rechargeAverageSubscriptionsPerCustomer,
    rechargeAverageSubscriptionsPerCustomerChart,
    rechargeReactivatedSubscribersChart,
    rechargeReactivatedSubscribers,
  },
};
